<template>
	<div class="book-components">		
 	 	<iframe  v-show="true"  :src="mapsSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0" style="position: absolute"  v-bind:style="{height: 'calc(100% - '+titleHeight+')'}"></iframe>
 	 	<!-- 文章内容 -->
    <div v-show="articleVisible"  class="menu-components" v-bind:style="{ transform:articleY}">     
      <img class="btn-navigation" src="static/img/comments/icon-navigation.png"  @click="handleNavigation"/>
      <img class="btn-comments" src="static/img/comments/btn-comments.png" @click="handleComment"/>
      <span class="comments-total">{{commentTotal}}</span>
      <iframe :src="articleSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0" style="position: relative" ></iframe>    
    </div> 
    <!-- 文章内容 END-->
    <!-- 地图导航 -->
    <div v-show="navigationVisible"  class="menu-components comment-navigation" v-bind:style="{ transform:navigationY}">     
      <iframe :src="navigationSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0" style="position: relative" ></iframe>    
    </div> 
    <!-- 地图导航 END-->
 	 	  
 	 	<!-- 评论 -->
 	 	<div v-show="commentVisible" class="menu-components comment-components" v-bind:style="{ transform:newClass.commentY}"> 
      <div class="submit-comment-wrap">
        <van-search ref="replyinput" placeholder="说点儿什么吧！" show-action  @search="submitComment()" @focus='hidshow=false' @blur='hidshow=true' v-model="commentContens" class="submit-comment-form">  <div slot="action" @click="submitComment"></div></van-search>
        <span class="btn-submit-comment"  @click="submitComment">发布</span>
      </div>
      <div class="comment-list-wrap">
        <div v-if="list.length==0 && (!loading)" style="text-align: center;">
          <van-tag plain type="success">暂无评论</van-tag>
        </div>
        <van-list v-model="loading" :finished="finished" @load="onLoad" loading-text = "正在加载..." :offset="300">
          <van-cell v-for="item in list" :key="item.id" class="comment-cell">
            <div><img class="profile-photo" src="static/img/comments/profile-photo.png"/><span class="profile-name">{{item.userName}}</span></div>
            <div class="comment-contents"><span>{{item.commentContent}}</span></div>
            <div>
              <span class="create-time">{{item.dateAndTimeStr}}</span>
              <span class="btn-reply" @click="reply()">回复</span>
            </div>  
          </van-cell>
        </van-list>
        <div style="height:1.37rem;">          
        </div>
      </div>
    </div>
    <!-- 评论 END-->   	
   	  
   	<!-- 底部导航 -->
	  <van-tabbar v-model="active" class="bottom-nav"  v-bind:style="{ backgroundColor:  activeColor,height: titleHeight}">		 
		 <van-tabbar-item :to="{path:'/',query:{view:1}}">
		    <span>鲜料</span>
		    <template slot="icon" slot-scope="props">
		      <img :src="props.active ? icon.newsActive : icon.news" />
		    </template>
		  </van-tabbar-item>
		  <van-tabbar-item  @click="displayMap">
		    <span>智图</span>
		    <template slot="icon" slot-scope="props">
		      <img :src="props.active ? icon.mapsActive : icon.maps" />
		    </template>
		  </van-tabbar-item> 		  
		  <van-tabbar-item :to="{path:'/',query:{view:2}}">
		    <span>趣玩</span>
		    <template slot="icon" slot-scope="props">
		      <img :src="props.active ? icon.payActive : icon.pay" />
		    </template>
		  </van-tabbar-item>
		  <van-tabbar-item  :to="{path:'/',query:{view:3}}">
		    <span>服务</span>
		    <template slot="icon" slot-scope="props">
		      <img :src="props.active ? icon.serviceActive: icon.service" />
		    </template>
		  </van-tabbar-item>
		</van-tabbar>
		<!-- 底部导航 END-->
	</div>
</template>

<script>
	import { Tabbar, TabbarItem } from 'vant'; 
 	import { Cell, CellGroup} from 'vant';
 	import { Row, Col } from 'vant';
	import axios from 'axios';
	import qs from 'qs';
	import { Toast,Dialog  } from 'vant'; 
  import { List,Search,Tag  } from 'vant';
  import request from '@/utils/request'
 import moment from 'moment'
 	
export default {
  name: 'Contact',
	components: {
		'van-tabbar':Tabbar,
		'van-tabbar-item':TabbarItem,	  	  
		'van-cell':Cell,
		'van-cell-group':CellGroup,
		'van-col':Col,
		'van-row':Row,
		'van-search':Search,
      'van-list': List,
      'van-tag': Tag,
		 
	},
  data () {
    return {
      
      active: 1,
      
        activeColor:"#222633",
        
      // HOST:'http://localhost:55214/Server',
       //  HOST:'http://z.lzgd.com.cn/LiuzhouTourism/Server',
      icon: {
        news:'static/img/tabbar/white/news2.png',
        newsActive:'static/img/tabbar/white/news-active.png',
        maps:'static/img/tabbar/white/map2.png',
        mapsActive:'static/img/tabbar/white/map-active.png',
        pay:'static/img/tabbar/white/pay.png',
        payActive:'static/img/tabbar/white/pay-active.png',
        service:'static/img/tabbar/white/service.png',
        serviceActive:'static/img/tabbar/white/service-active.png',
      },
      
      //mapsSrc:'http://z.lzgd.com.cn/inliuzhou/2018/lzly/default.aspx',
  // mapsSrc:'http://localhost:55214/Server/View/Map.aspx',
  mapsSrc:'http://z.lzgd.com.cn/LiuzhouTourism/Server/View/Map.aspx',
        titleHeight:'55px',
        navIconHeight:'0',
        
          
        //-导航=============================================================      
        navigationVisible:false,
        navigationY:'none',
        navigationSrc:'',
        latlng:'',
        //-导航 end =========================================================
        
        
        //-文章=============================================================      
        articleVisible:false,
        articleY:'none',
        articleSrc:'',
        commentTotal:0,
        //-文章 end =========================================================
        
        
        //-评论=============================================================      
        commentVisible:false,
        newsId:0,//当前评论对应新闻ID
        commentContens:'',
            listQuery: { 
              newsId:0,
              pageIndex: 1,
              pageSize: 10,
            } ,     
        newsType:201,
        list: [],
        loading: false,
        finished: false,
         newClass: {
          activeHeight: 'calc(100% - 1.37rem - 0)',
          commentY:'translateY(-100%)',
          articleHeight:'0',
        },
        lastLoadTime:0,
        //-评论 end =========================================================
        //-导航 =========================================================
        docmHeight: document.documentElement.clientHeight,  //默认屏幕高度
        showHeight: document.documentElement.clientHeight,   //实时屏幕高度
        hidshow:true  //显示或者隐藏footer
        //-导航 end =========================================================
    }
  },
  showHeight:function() {
    console.log("this.docmHeight",this.docmHeight)
    console.log("this.showHeight",this.showHeight)
        if(this.docmHeight > this.showHeight){
            this.hidshow=false
        }else{
            this.hidshow=true
        }
    },
  mounted() { 
    
  	document.title = '智图';
  	let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  	let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  	let elementWith = (w*0.1826);
  	if(w>750){
  		elementWith = 137;
  	}
  	this.titleHeight =elementWith +'px';
  	this.navIconHeight =(elementWith*0.3764) +'px'; 
  	let vm =this; 
  	window.onresize = function temp() { 
	  	let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	  	let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	  	let elementWith = (w*0.1826);
        vm.titleHeight = elementWith +'px'
  		vm.navIconHeight =(elementWith*0.3764) +'px'; 
    };
  },
     created() {           	
      // 增加一个postMessage来监听消息
      window.addEventListener('message', this.postMessageListener)
  },
    methods: {
        //监听子框架
        postMessageListener(e){
          console.log("postMessageListener",e.data.type)
          console.log(e.data)
          if(e.data.view && e.data.view=='maps'){
            if(e.data.type && e.data.type=='closeComment'){
              this.closeComment();
            } else if(e.data.type && e.data.type=='setCommentTotal'){         
              this.commentTotal = e.data.commentTotal           
            } else if(e.data.type && e.data.type=='setMapPosition'){         
              this.latlng = e.data.latlng           
            }  else if(e.data.type && e.data.type=='displayComment'){              
              this.newsId = e.data.newsId
              handleComment();              
            } else if(e.data.type && e.data.type=='displayArticle'){ //显示文章窗口
              this.newsId = e.data.newsId
              this.articleY = 'translateY(-100%)'  
              this.articleVisible = true              
              let vm = this
              setTimeout(function(){              
                vm.articleY = 'none'  
                vm.articleSrc = 'http://z.lzgd.com.cn/LiuzhouTourism/Server/View/MapArticle.aspx?id='+vm.newsId
              },50)
            }
          }
        },
        
       
        
        //-文章 =============================================================
        //点击评论按钮
        handleComment(){
          this.displayComment()
          let vm = this
          setTimeout(function(){
            vm.getComment(vm.newsId)
          },300);
        },
        //点击导航按钮
        handleNavigation(){ 
          this.navigationY = 'translateY(-100%)'  
          this.navigationVisible = true              
          let vm = this
          setTimeout(function(){              
            vm.navigationY = 'none'  
            vm.navigationSrc = "http://z.lzgd.com.cn/LiuzhouTourism/Server/View/MapNavigate.aspx?endLatLng="+vm.latlng;
          },50)
        },
        //-文章 end =========================================================
        
        
        //-评论=============================================================
         //发布评论
        submitComment(){
            if(this.commentContens == null || this.commentContens=='') {
              Dialog.alert({
                message: '请填写评论内容'
              }).then(() => {
                // on close
              });
              return;
            }
            Toast.loading({
              mask: true,
              duration:0,
              message: '正在发布...'
            });
            let vm = this
            let data = {newsId:this.newsId,commentContens:this.commentContens};                   
            //if(userName!='' && contents!=''){
              //data.commentContens =  data.commentContens + "　@"+userName+"："+contents
            //}
            data = qs.stringify(data);
            request.post(this.HOST+'/Action/NewsCommentAction.aspx?action=createComments',data)
            .then(function (res) {
              Toast.clear();               
              if(res.data.state==1){
                let comments = {'userName':'热心网友','commentContent':vm.commentContens,'dateAndTimeStr':moment().format('YYYY-MM-DD HH:mm:ss')}            
                vm.list.unshift(comments)
                vm.commentContens = ''
                Toast('发表成功，感谢参与');
             } else {
                Toast(res.data.msg); 
              }
            })
            .catch(function (response) {
              Toast.clear();
              Toast('网络连接失败，请重试。'); 
              console.log(response);
            });          
          },
        //回复评论
        reply(){
          this.$refs['replyinput'].$el.children[0].children[1].children[0].children[0].focus()
          this.$refs['replyinput'].$el.children[0].children[1].children[0].children[0].select()
        },
        //显示评论窗口
         displayComment(){ 
           this.commentVisible = true
           //清空数据
           this.listQuery.pageIndex = 1
           this.list = []
           this.loading = true
           let vm = this
           setTimeout(function(){
              vm.newClass.commentY = 'translateY(0)'  
           },50);           
         },
         //关闭评论窗口
         closeComment(){ 
           this.finished  = true
           this.newClass.commentY = 'translateY(-100%)';
           let vm = this
           setTimeout(function(){
              vm.commentVisible = false
           },400); 
         },
         //获取评论数据 
         getComment(newsId){
           console.log(2222222222222)
            let vm  = this;       
            //Toast('正在加载...');//return;
            let data =this.listQuery;
            data.newsId = newsId;
            data = qs.stringify(data);
            request.post(this.HOST+'/Action/NewsCommentAction.aspx?action=getComments',data)
          .then(function (res) {
              vm.loading = false;
            if(res.data.state==1){ 
              console.log(res.data)
              for(var i =0;i<res.data.list.length;i++){
                try{
                  res.data.list[i].userName  = '热心网友'
                  vm.list.push(res.data.list[i]);
                }catch(e){
                  
                }
              }  
              if(res.data.list.length<=0 && vm.listQuery.pageIndex >1){
                Toast('没有啦');
                vm.finished = true;
              }else{
                vm.listQuery.pageIndex++;
              }
              //vm.list.push(res.data.list);  
              //Toast.clear();
           } else {
              Toast(res.data.msg); 
            }
          })
          .catch(function (response) {
            console.log(response);
          });
        
        
        
      },
         //加载评论数据
         onLoad() {
          if(!this.finished){
            this.getComment(this.newsId);
          }
        },
        //-评论 end ==========================================================
        
        
        
        //-底部导航  =========================================================        
        //导航栏跳转
        displayMap(){
          //关闭导航窗口
          if(this.navigationY == 'translateY(0)' || this.navigationY == 'none' ){
            this.navigationY = 'translateY(-100%)'         
            return;
          }
          //关闭评论窗口
          if(this.newClass.commentY == 'translateY(0)' ){
            this.newClass.commentY = 'translateY(-100%)'         
            return;
          }
          //关闭文章窗口
          if(this.articleY == 'translateY(0)' || this.articleY == 'none' ){
            this.articleY = 'translateY(-100%)'         
            return;
          }
          
          
          
          
           var post = {type:1,data:2};  
              window.frames[0].postMessage(post,'*');
              
              
              
              return;
          
          let type = this.$route.query.type;
          switch(type){
              case 1:
                document.title = '城事精选' 
              break;
              case 2:
                document.title = '闲游头条' 
              break;
              case 3:
                document.title = '乡旅动态' 
              break;
              case 4:
                document.title = '村长甄选' 
              break;
              case 401:
                document.title = '当地美食' 
              break;
            }
          
          if(this.back=='search'){
              this.$router.push({
                  path: '/',
                  query: {
                    view: 4
                  }
               });
          }else if(this.articleSrc==''){
            this.$router.push({
                  path: '/',
                  query: {
                    view: 1
                  }
               });
          } else{
              //显示列表
              this.newClass.activeHeight = '100%';
              this.newClass.articleHeight = '0';          
              this.articleSrc = '';
           }
        },
        //-底部导航 end =====================================================
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .book-components{
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
 
  
  
  /* 导航  */
 .comment-navigation{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 4;
 }
 /* 导航 end*/
  
 /* 评论 */
 .comment-components{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 3;
 }
  .submit-comment-wrap{
    background-color: #e8e9eb;
  }
  .submit-comment-form{
    height: 85px;
  }
  .btn-submit-comment{
    position: absolute;
    top:34.5%;
    right:4.5%;
    font-size: 18px;
    color: #8a8a8a;
  }  
  
  .comment-list-wrap {
    position: relative;
    height:100%;
    overflow-y: auto;
    -webkit-overflow-scrolling:touch;
    overflow-x: hidden;
    margin-top: 84px;
  } 
  .profile-photo {
    width: 15%;
    max-width: 48px;
    vertical-align: middle;    
  }
  .profile-name {
    vertical-align: middle;
    margin-left: 10px;
    color: #089141;
  }
  .comment-contents {
    padding: 10px 0;
    color: #232635;
    font-size: 15px;
  }
  .create-time{
    color: #7c7c7c;
  }
  .btn-reply {
    float: right;
    color: #089141;
    padding: 5px 17px;
     margin-right: -17px;
  } 
  
@media (max-width: 320px) {   
    .btn-submit-comment{
    position: absolute;
    top:38%;
    right:4%;
    font-size: 15px;
  }  
  
  }
    .comment-msg{
    text-align: center;
  }
 /* 评论 end*/

  /* 文章 */
 .btn-navigation{
    position: fixed;
    top: 4.5%;
    width: 11%;
    right: 8.3%;
    z-index: 2;
 }
 
 .btn-comments{
    position: fixed;
    top: 16.5%;
    width: 11%;
    right: 8.3%;
    z-index: 2;
 }
 .comments-total{
    position: fixed;
    top: 15%;
    right: 7%;
    z-index: 2;
    color: #fff;
    font-size: 15px;
    font-weight: normal;
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
    text-align: center;
    box-sizing: border-box;
    padding: 0 6px;    
    min-width: 28px;
    line-height: 28px;
    border-radius: 16px;
    background-color: rgba(0, 145, 67, 0.8);
 }
 /* 文章 end*/
</style>
<style>
  
  .menu-components{
    position:relative;
    height: calc(100% - 1.37rem);
    background-color: #FFFFFF;
      overflow-x: hidden; 
      overflow-y: scroll; 
      -webkit-overflow-scrolling:touch;
      -webkit-transition: transform 400ms;
      transition: transform 400ms; 
        transition-timing-function: ease, ease;
    -webkit-transition-timing-function: ease, ease;
      
   -webkit-transform: translateZ(0);
   -moz-transform: translateZ(0);
   -ms-transform: translateZ(0);
   -o-transform: translateZ(0);
   transform: translateZ(0);
  }
   .submit-comment-wrap{
     position: fixed;
     top:0;
     left: 0;
     z-index: 2;
    width: 100%;
   }
  .submit-comment-wrap .van-icon-search{
    display: none;
  }
  .submit-comment-wrap .van-field__control{
        width: 100%;
    height: 38px;
    text-align: center;
    font-size: 15px;
    padding-right: 0; 
  }
   .submit-comment-wrap  .van-search .van-cell{
    -webkit-box-flex: none; 
    -ms-flex:none; 
    flex: none; 
    border-radius: 25px;
        padding: 0;
            width: 83%;
    border: 1px solid #999999;

  }
    .submit-comment-wrap .van-search .van-field__icon{
        right: 5%;
  }
  
  
    .submit-comment-wrap .van-search .van-icon-clear{
        right: 5%;
  }
  
  
  
  
    .submit-comment-wrap .comment-cell::after {
    left: 15px !important;
    right: 0  !important;
    width: auto  !important;
    -webkit-transform: scale(1,.5)  !important;
    transform: scale(1,.5)  !important;
    border-color: #b8b8b8 !important;
    border-bottom-width: 1px  !important;
}
  /* 评论Confirm弹窗 */
   .submit-comment-wrap  .van-dialog__message{
    text-align: center;
  }
  
 	  .submit-comment-wrap 	.van-tabbar-item__icon{
		width: 100%;
		height: 31.64%;
		display:inline;
    text-align: center;
	}
	  .submit-comment-wrap  .van-tabbar-item__icon img{
				height:100%;
				width: auto !important;
				margin: auto;
			}
			
 
</style>



// WEBPACK FOOTER //
// src/components/Maps.vue